import { accountDemo, utenteInterno } from "@/lib/marchi";

/**
 * IL MODELLO SCELTO DAL TEAM (02/11/2026): GPT-6 Luna o Claude Haiku 5.5.
 *
 * Il banco di prova di Davide: chi e' del team interno sceglie in Impostazioni
 * chi scrive le SUE risposte. La scelta sta su questo dispositivo, non nel
 * profilo: e' uno strumento di prova, non una preferenza dell'account. Decide
 * comunque il server (supabase/functions/_shared/fornitore.ts): se la mandasse
 * un cliente, verrebbe ignorata.
 */
export type FornitoreModello = "openai" | "anthropic";

const CHIAVE = "datacom.fornitore_llm";

export const NOME_MODELLO: Record<FornitoreModello, string> = {
  openai: "GPT-6 Luna",
  anthropic: "Claude Haiku 5.5",
};

/** Chi vede l'interruttore: il team interno, non gli account demo dei revisori degli store. */
export function puoScegliereModello(email?: string | null): boolean {
  return utenteInterno(email) && !accountDemo(email);
}

/** La scelta salvata, o null se non si e' mai toccato l'interruttore. */
export function fornitoreScelto(): FornitoreModello | null {
  try {
    const v = localStorage.getItem(CHIAVE);
    return v === "openai" || v === "anthropic" ? v : null;
  } catch {
    return null;
  }
}

export function scegliFornitore(f: FornitoreModello): void {
  try {
    localStorage.setItem(CHIAVE, f);
  } catch {
    // Archivio del browser non disponibile (navigazione privata): la chat usa il predefinito.
  }
}

/** La riga sotto la risposta: «Nota: scritta da Claude Haiku 5.5». */
export function notaScrittoDa(modello: string): string {
  return `scritta da ${modello}`;
}
